import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, LockIcon } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-20 bg-gradient-to-br from-sky-500 to-sky-600 text-white text-center" data-id="element-38">
      <div className="max-w-3xl mx-auto px-6" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-playfair font-bold mb-6 leading-tight" data-id="element-41">
            Your Opportunity To Learn Something Most People Never Do
          </h2>
          <p className="text-white/90 text-lg mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-42">
            Understanding how sugar interacts with your oral environment could
            change the way you think about dental health forever. Get instant
            access today and discover the simple insights shared inside The
            Dental Sugar Hack.
          </p>

          <a href="https://www.abeautifulage.com//cart/53861141348718:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-5 px-12 rounded-full transition-all transform hover:scale-105 shadow-xl text-xl mb-4 w-full sm:w-auto" data-id="element-43">
            Get Instant Access Now
          </a>

          <p className="text-white/80 text-sm mb-8" data-id="element-44">
            Special Introductory Price:{' '}
            <span className="font-bold text-white" data-id="element-45">$17</span>
          </p>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm" data-id="element-46">
            <div className="flex items-center" data-id="element-47">
              <DownloadIcon size={16} className="mr-2" data-id="element-48" />
              <span data-id="element-49">Instant Digital Access</span>
            </div>
            <div className="flex items-center" data-id="element-50">
              <LockIcon size={16} className="mr-2" data-id="element-51" />
              <span data-id="element-52">Secure Checkout</span>
            </div>
            <div className="flex items-center" data-id="element-53">
              <ShieldCheckIcon size={16} className="mr-2" data-id="element-54" />
              <span data-id="element-55">60-Day Satisfaction Guarantee</span>
            </div>
          </div>

          <p className="text-white/60 text-xs mt-10 max-w-2xl mx-auto leading-relaxed" data-id="element-56">
            Disclaimer: This product is intended for educational purposes only.
            Results vary from person to person. Always consult a qualified
            healthcare professional regarding any dental concerns.
          </p>
        </motion.div>
      </div>
    </section>;
}